import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useGetDta } from '../../../hooks/useGetDta';
import LoadinSpin from '../../ui/LoadinSpin';
import { useEffect } from 'react';

const SuscripcionesUser = ({ id }) => {
    const { loading, data, getInfo } = useGetDta(`openpay/suscriptions`, { id }, 'PUT');
    useEffect(() => {
        getInfo(`openpay/suscriptions`, { id }, 'PUT');
    }, [id]);
    if (loading) return <LoadinSpin />;
    return (
        <div>
            <Row>
                {data.map(({ id, card, plan, trial_end_date }) => (
                    <Col xxl={3} md={6} key={Math.random()}>
                        <Card>
                            <Card.Body>
                                <div className="text-center">
                                    <h4 className="mt-3 my-1">
                                        SUSCRIPCIÓN ACTIVA
                                        <i className="mdi mdi-check-decagram text-primary"></i>
                                    </h4>
                                    <h5>{plan}</h5>
                                    <p className="mb-0 text-muted">
                                        <i className="mdi mdi-credit-card-check-outline me-1"></i>
                                        {card.card_number}
                                    </p>
                                    <hr className="bg-dark-lighten my-3" />
                                    <h5 className="mt-1 fw-semibold text-muted">Banco:{card.bank_name}</h5>
                                    <h5 className=" fw-semibold text-muted text-capitalize">
                                        Tipo:{card.type} {card.brand}
                                    </h5>
                                    <h5 className="mt-1 fw-semibold text-muted">Fin de periodo:{trial_end_date}</h5>
                                    <h5 className=" fw-semibold text-muted text-capitalize">ID:{id}</h5>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default SuscripcionesUser;
